module.exports = __webpack_public_path__ + "static/img/hall_1.9de8973.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/hall_1.jpg
// module id = jGwn
// module chunks = 3